import {
  FETCH_CISSCT_BEGIN,
  FETCH_CISSCT_SUCCESS,
  FETCH_CISSCT_FAILURE,
  FETCH_CISSCT_BY_NDOSSIER,
  FETCH_CISSCT_BY_INDEX,
  CHANGE_INDEX_VALUE
} from '../actions/cissctActions';

const initialState = {
  items: [],
  itemsNdossier: [],
  item: {},
  index: 0,
  loading: false,
  error: null,
}

export default function cissctReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CISSCT_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }

    case FETCH_CISSCT_SUCCESS: {
      return {
        ...state,
        loading: false,
        items: action.payload.items
      }
    }

    case FETCH_CISSCT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        items: []
      };
    }

    case FETCH_CISSCT_BY_NDOSSIER: {
      const { ndossier } = action.payload;
      const item = state.items
        .filter(cissct => cissct.ndossier === ndossier)
        .sort((a, b) => b.cissct_index - a.cissct_index)[0]
      return {
        ...state,
        itemsNdossier: item ? item : {},
      };
    }

    case FETCH_CISSCT_BY_INDEX: {
      const { ndossier, index } = action.payload;
      const item = state.items.find(cissct => cissct.ndossier == ndossier && cissct.cissct_index == index);
      return {
        ...state,
        item: item ? item : {},
      };
    }

    case CHANGE_INDEX_VALUE: {
      return {
        ...state,
        index: action.payload.index
      };
    }

    default:
      return state
  }
}